/** @format */

// import { findTreeDataByAll, findTreeDataByTheG, findTreeDataByG } from '@/api/platform/org/group'
import { groupFindTreeDataByAll as findTreeDataByAll } from '@/api/position/index';
import { ActionUtils } from '@/utils/action';

export default {
	methods: {
		findTreeDataTypes(type, params, methods) {
			return new Promise((resolve, reject) => {
				switch (type) {
					case '1':
						methods
							.findTreeDataByAll({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '2':
						methods
							.findTreeDataByTheG({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
					case '3':
						methods
							.findTreeDataByG({ params })
							.then((data) => {
								resolve(data);
							})
							.catch(() => {
								reject([]);
							});
						break;
				}
			});
		},
		// 查询全部-1
		findTreeDataByAll(paramsOptions) {
			const params = paramsOptions.params;
			return new Promise((resolve, reject) => {
				findTreeDataByAll(ActionUtils.formatParams(params))
					.then((res) => {
						resolve(res);
					})
					.catch(() => {
						reject([]);
					});
			});
		},

		// 查询当前-2
		// findTreeDataByTheG(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByTheG(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },

		// 查询指定-3
		// findTreeDataByG(paramsOptions) {
		// 	const params = paramsOptions.params;
		// 	return new Promise((resolve, reject) => {
		// 		findTreeDataByG(params)
		// 			.then((res) => {
		// 				resolve(res.data);
		// 			})
		// 			.catch(() => {
		// 				reject([]);
		// 			});
		// 	});
		// },
	},
};
